/**
 * The browsers installed on this computer, and opening an address in one of them, privately or not (browsers.rs) —
 * for an agent's sign-in with a second account (components/SignInOpener.tsx). Desktop only.
 */

import { isDesktop } from './desktop'

export interface InstalledBrowser {
  id: string
  name: string
  /** The one the system opens links in. */
  default: boolean
}

async function invoke<T>(command: string, args?: Record<string, unknown>): Promise<T> {
  const { invoke: call } = await import('@tauri-apps/api/core')
  return call<T>(command, args)
}

export function browsersList(): Promise<InstalledBrowser[]> {
  return isDesktop() ? invoke<InstalledBrowser[]>('browsers_list') : Promise.resolve([])
}

/** Opens `url` in `browser` (the default with null), in a private window when asked. */
export function browserOpen(url: string, browser: string | null, privately: boolean): Promise<void> {
  return invoke<void>('browser_open', { url, browser, private: privately })
}
